import { IoClose } from "react-icons/io5";
import { FaCheckSquare } from "react-icons/fa";

export const CATEGORY = [
    { id: 1, name: "Investor" },
    { id: 2, name: "Organization" },
    { id: 3, name: "Individual" },
    { id: 4, name: "Corporate" },
    { id: 5, name: "Group" },
    { id: 6, name: "Project" },
    { id: 7, name: "Staff" },
    { id: 8, name: "Non-profit" },
    { id: 9, name: "Core" },
    { id: 10, name: "Support" },
    { id: 11, name: "Finance" },
    { id: 12, name: "Regulatory" },
    { id: 13, name: "Education" },
    { id: 14, name: "Research" },
    { id: 15, name: "Media" },
    { id: 16, name: "Corporate" },
    { id: 17, name: "Professional" },
    { id: 18, name: "Philanthropy" },
];

export const ENTITY_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "dob",
        title: "Date of Birth",
    },
    {
        dataIndex: "entityType",
        title: "Entity Type",
    },
    {
        dataIndex: "registrationNo",
        title: "Registration No",
    },
    {
        dataIndex: "country",
        title: "Country",
    },
    {
        dataIndex: "focusArea",
        title: "Focus Area",
    },
];

export const ENTITY_TYPE_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "category",
        title: "Category",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
];

export const INVESTMENT_MANDATE_TYPE_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
];

export const ASSET_TYPE_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
];

export const ASSETS_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "assetType",
        title: "Asset Type",
    },
    {
        dataIndex: "initialValue",
        title: "Initial Value",
    },
    {
        dataIndex: "current",
        title: "Current",
    },
    {
        dataIndex: "date",
        title: "Date",
    },
];


export const SPONSOR_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "entity_name",
        title: "Entity Name",
    },
    {
        dataIndex: "role",
        title: "Role",
    },
    {
        dataIndex: "experience_years",
        title: "Experience Years",
    },
    {
        dataIndex: "gender",
        title: "Gender",
    },
    {
        dataIndex: "email",
        title: "Email",
    },
    {
        dataIndex: "assessment_score",
        title: "Assessment Score",
    },
    {
        dataIndex: "ESG_awareness_score",
        title: "ESG Awareness Score",
    },
];

export const FAMILY_OFFICE_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "legacyGoal",
        title: "Legacy Goal",
    },
    {
        dataIndex: "governanceModel",
        title: "Governance Model",
    },
    {
        dataIndex: "totalAssets",
        title: "Total Assets",
    },
    {
        dataIndex: "portfolioEntities",
        title: "Portfolio Entities",
        render: (entities: any) => entities?.join(", ") || "-",  // fallback to "-" if empty
    },
    {
        dataIndex: "complianceScore",
        title: "Compliance Score",
    },
];

export const INVESTMENT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "assetType",
        title: "Asset Type",
    },
    {
        dataIndex: "amount",
        title: "Amount",
    },
    {
        dataIndex: "startDate",
        title: "Start Date",
    },
    {
        dataIndex: "expROI",
        title: "Exp ROI",
    },
    {
        dataIndex: "actualROI",
        title: "Actual ROI",
    },
    {
        dataIndex: "mandate",
        title: "Mandate",
    },
    {
        dataIndex: "familyOffice",
        title: "Family Office",
    },
];

export const AGENT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Agent Id",
    },
    {
        dataIndex: "agentCode",
        title: "Agent Code",
    },

    {
        dataIndex: "agentName",
        title: "Agent Name",
    },
    {
        dataIndex: "role",
        title: "Role",
    },
    {
        dataIndex: "associatedReligion",
        title: "Associated Religion",
    },
    {
        dataIndex: "attributes",
        title: "Attributes",
    },
    {
        dataIndex: "weightage",
        title: "Weightage",
    },
    {
        dataIndex: "assessmentFunction",
        title: "Assessment Function",
    },
    {
        dataIndex: "approvalAuthority",
        title: "Approval Authority",
    },
    {
        dataIndex: "tokenInfluenceRuleId",
        title: "Token Influence Rule Id",
    },
    {
        dataIndex: "parentAgentCode",
        title: "Parent Agent Code",
    },
];

export const DOCUMENT_TYPE_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
    {
        dataIndex: "entityTypeMaster",
        title: "Entity Type",
    },
    {
        dataIndex: "isMandatory",
        title: "Is Mandatory",
        render: (value: any) =>
            value ? (
                <FaCheckSquare size={22} color="green" />
            ) : (
                <IoClose size={22} color="red" />
            ),
    },
    {
        dataIndex: "expiryApplicable",
        title: "Expiry Applicable",
        render: (value: any) =>
            value ? (
                <FaCheckSquare size={22} color="green" />
            ) : (
                <IoClose size={22} color="red" />
            ),
    },
    {
        dataIndex: "fileFormat",
        title: "File Format",
    },
];

export const DOCUMENT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "documentName",
        title: "Name",
    },
    {
        dataIndex: "documentNumber",
        title: "Document Number",
    },
    {
        dataIndex: "documentType",
        title: "Document Type",
    },
    {
        dataIndex: "entityMaster",
        title: "Entity Master",
    },
    {
        dataIndex: "entityTypeMaster",
        title: "Entity Type",
    },
    {
        dataIndex: "fileName",
        title: "File Name",
    },
];

export const ORGANIZATION_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Organization Id",
    },
    {
        dataIndex: "name",
        title: "Organization Name",
    },
    {
        dataIndex: "code",
        title: "Organization Code",
    },
    {
        dataIndex: "contactPerson",
        title: "Contact Person",
    },
    {
        dataIndex: "contactEmail",
        title: "Contact Email",
    },
    {
        dataIndex: "contactPhone",
        title: "Contact Phone",
    },
    {
        dataIndex: "website",
        title: "Website",
    },
    {
        dataIndex: "city",
        title: "City",
    },
    {
        dataIndex: "stateId",
        title: "State Id",
    },
    {
        key: "state",
        dataIndex: ["state", "name"],
        title: "State Name",
    },
    {
        dataIndex: "countryId",
        title: "Country Id",
    },

    {
        key: "country",
        dataIndex: ["country", "name"],
        title: "Country name",
    },


    {
        dataIndex: "dependentOrgCode",
        title: "Dependent Organization Code",
    },
    {
        dataIndex: "organizationType",
        title: "Organization Type",
    },
    {
        dataIndex: "address",
        title: "Address",
    },
];

export const USER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Name",
    },
    {
        key: "mobileNo",
        dataIndex: "phoneNumber",
        title: "Mobile Number",
    },
    {
        key: "email",
        dataIndex: "email",
        title: "Email",
    },
    {
        key: "role",
        dataIndex: "userRole",
        title: "Subscriber",
    },
    {
        key: "group",
        dataIndex: "userGroup",
        title: "User Group",
    },
    // {
    //     key: "package",
    //     dataIndex: "packageMaster",
    //     title: "Package Name",
    // },
    // {
    //     key: "packageType",
    //     dataIndex: "packageType",
    //     title: "Package Type",
    // }
];

export const USER_SUBSCRIBER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Subscriber Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Subscriber Name",
    },
];

export const USER_GROUP_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Group Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "User Group Name",
    },
];

export const COUNTRY_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Country Id",
    },
    {
        key: "countryName",
        dataIndex: "name",
        title: "Country Name",
    },
];
export const STATE_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "State Id",
    },
    {
        key: "countryName",
        dataIndex: ["country", "name"],
        title: "Country Name",
    },
    {
        key: "stateName",
        dataIndex: "name",
        title: "State Name",
    },
];

export const RISK_ASSESSMENT_LOG_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Id",
    },
    {
        key: "assetName",
        dataIndex: "assetName",
        title: "Asset Name",
    },
    {
        key: "assetType",
        dataIndex: "assetType",
        title: "Asset Type",
    },
    {
        key: "entityName",
        dataIndex: "entityName",
        title: "Entity Name"
    },
    {
        key: "entityType",
        dataIndex: "entityType",
        title: "Entity Type"
    },
    // {
    //     key: "llmReqAsset",
    //     dataIndex: "llmReqAsset",
    //     title: "LLM Req Asset",
    // },
    // {
    //     key: "llmResAsset",
    //     dataIndex: "llmResAsset",
    //     title: "LLM Res Asset"
    // },
    // {
    //     key: "llmReqEntity",
    //     dataIndex: "llmReqEntity",
    //     title: "LLM Req Entity"
    // },
    // {
    //     key: "llmResEntity",
    //     dataIndex: "llmResEntity",
    //     title: "LLM Res Entity"
    // },
    {
        key: "parentEntityName",
        dataIndex: "parentEntityName",
        title: "Parent Entity Name"
    },
    {
        key: "source",
        dataIndex: "source",
        title: "Source"
    },
    {
        key: "user",
        dataIndex: "user",
        title: "User"
    }
];